export class PayOutstandingRequest {
  useWalletBalance: boolean;
  reason: string;
}
